import React from 'react'

import {
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  ChartIntensity,
  IIntensityDataPoint,
  SingleWidgetContainer,
  EmptyState
} from '@tdp/modules/apps';

export const IntensityWidget: React.FC<{
  status: AnalyticsV2WidgetLoadingState
  size: AnalyticsV2WidgetSize
  data?: IIntensityDataPoint
  header: string
}> = ({ data, status, header, size }) => {
  const widget = data
    ? <ChartIntensity data={data} />
    : <EmptyState />;

  return <SingleWidgetContainer
    size={size}
    header={header}
    loadingState={status}
    widget={widget}
  />
}